<!-- Products -->
<ng-container *ngIf="showProducts">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col sm:flex-row justify-between items-center mb-8">
        <h2 class="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4 sm:mb-0">
          {{category?.title}}
        </h2>
        <div class="flex flex-wrap justify-center sm:justify-start gap-2">
          <button class="btn btn-xs sm:btn-sm btn-outline btn-secondary rounded-full">Sort</button>
          <button class="btn btn-xs sm:btn-sm btn-outline btn-secondary rounded-full">Filter</button>
          <button class="btn btn-xs sm:btn-sm btn-outline btn-secondary rounded-full">Brand</button>
          <button class="btn btn-xs sm:btn-sm btn-outline btn-secondary rounded-full">Available</button>
        </div>
      </div>
      <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
        <ng-container *ngFor="let product of products">
            <app-product-card
              [product]="product"
              (onAddedItem)="addednewItem($event, product)"
            ></app-product-card>
          </ng-container>
          
       
      </div>
    </div>
  </ng-container>

<!-- Subcategories -->
<ng-container *ngIf="!showProducts">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 class="text-2xl sm:text-3xl font-extrabold text-gray-900 mb-6 sm:mb-8 text-center">{{category?.title}}</h2>
        <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
            <div class="group" *ngFor="let subcategory of subcategories">
                <div class="relative overflow-hidden rounded-lg shadow-md transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-lg">
                    <div class="relative pb-[100%] bg-gray-100">
                        <img class="" *ngIf="subcategory?.images && subcategory.images.length > 0 && subcategory.images[0]?.image"
                             [src]="subcategory.images[0].image" 
                             [alt]="subcategory?.title"
                             class="p-12 absolute inset-0 w-full h-full object-cover object-center transition-transform duration-300 group-hover:scale-110"
                             (error)="error.handleImageError($event)">
                        <div *ngIf="!subcategory?.images || subcategory.images.length === 0 || !subcategory.images[0]?.image" 
                             class="absolute inset-0 flex items-center justify-center text-gray-500">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 sm:h-16 sm:w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            </svg>
                        </div>
                    </div>
                    <div class="absolute inset-0 bg-black bg-opacity-40 transition-opacity duration-300 opacity-0 group-hover:opacity-100"></div>
                    <div class="absolute bottom-0 left-0 right-0 p-3 sm:p-4 text-white transform translate-y-full transition-transform duration-300 group-hover:translate-y-0">
                        <p class="text-xs sm:text-sm font-medium">
                            Explore {{subcategory?.title | lowercase}} products
                        </p>
                    </div>
                    <a [routerLink]="[subcategory.slug]" class="absolute inset-0 z-10">
                        <span class="sr-only">View {{subcategory?.title}} subcategory</span>
                    </a>
                </div>
                <h3 class="mt-2 sm:mt-3 text-sm sm:text-base font-semibold text-gray-900 group-hover:text-secondary transition-colors duration-300 truncate">
                    {{subcategory?.title}}
                </h3>
            </div>
        </div>
    </div>
</ng-container>